import React from "react";
import Xmark from "../../assets/images/smallxmark.png";
import searchIcon from "../../assets/images/Search.png";
import plus from "../../assets/images/Frameplus.png";
import "./addNewPlace.css";
// import ModalTemplate from '../modal/ModalTemplate';
// import close from "../../assets/images/smallxmark.png"
// import { useState } from 'react';
import { useNavigate } from "react-router";

function AddNewPlace() {
  // const [modalActive, setModalActive] = useState(false)
  const navigate = useNavigate();
  return (
    <>
      <div className="new-place-content">
        <div>
        <div className="new-place-top">
          <p className="title2" style={{margin: "10px 0" }}>
            Add new place
          </p>
          <img onClick={() => navigate(-1)} src={Xmark} alt="close" />
        </div>

        <div
          className="serch-input"
          style={{ width: "100%", height: "47px", marginTop: "1.7rem" }}
        >
          <img src={searchIcon} alt="search" style={{ paddingLeft: "5px" }} />
          <input
            className="search-place"
            name="destination"
            placeholder="Search place"
          />
        </div>
        <div style={{ marginTop: "2rem", borderTop: "1px solid #CDD0E1" }}>
          <p className="headline2" style={{padding: "15px 0", color:"var(--gray100)"}}>
            Or add a custom place
          </p>
        </div>
        <div className="trip-input">
          <label style={{ fontSize: "13px",color:"var(--gray80)"}}>Add place name</label>
          <input
            type="text"
            className="input-trip"
            name="placename"
            placeholder="Add place name"
          />
        </div>
        <div className="addImage" style={{ marginTop: "2.5rem" }}>
          <p className="body4" style={{ fontSize: "13px", color:"var(--gray80"}}>Add image</p>
          <div className="addImage-content">
            <img src={plus} alt="plus" />
          </div>
        </div>
        </div>
        <div className="save-new-place">
          <div className="save-btn-new-place">Save</div>
        </div>
      </div>
      {/* <ModalTemplate active={modalActive} setActive={setModalActive}>
                <div style={{display:"flex", flexDirection: "row-reverse"}} onClick={()=>setModalActive(false)}>
                    <img src={close} alt="xmark"/>
                </div>
                <p style={{textAlign:"center", fontSize:"20px", fontWeight:"700", margin:"8px 0"}}>Confirm delete</p>
                <p style={{textAlign:"center",fontSize:"15px",margin:"10px 0 25px",color: "#424450",
                  opacity:"0.8"}}>By deleting this place will remove all added items from this itinerary</p>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <button style={{border:"none", background:"none", backgroundColor:"#E6F6F5",
                      borderRadius: "8px", color:"#00857D",padding:"12px 34px"}}>Cancel</button>
                    <button style={{border:"none", background:"none", backgroundColor:"rgba(240, 103, 84, 0.2)",
                      borderRadius: "8px", color:"#F06754",padding:"12px 34px"}}>Delete</button>
                </div>
            </ModalTemplate > */}
    </>
  );
}
export default AddNewPlace;
